import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTick = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8 0.484863C12.4183 0.484863 16 4.06659 16 8.48486C16 12.9031 12.4183 16.4849 8 16.4849C3.58172 16.4849 0 12.9031 0 8.48486C0 4.06659 3.58172 0.484863 8 0.484863ZM8 1.48486C4.13401 1.48486 1 4.61887 1 8.48486C1 12.3509 4.13401 15.4849 8 15.4849C11.866 15.4849 15 12.3509 15 8.48486C15 4.61887 11.866 1.48486 8 1.48486ZM11.3584 6.13131C11.532 6.30488 11.5513 6.5743 11.4163 6.76917L11.3584 6.83842L7.35355 10.8433C7.17999 11.0169 6.91056 11.0361 6.71569 10.9011L6.64645 10.8433L4.64645 8.84328C4.45118 8.64802 4.45118 8.33144 4.64645 8.13618C4.82001 7.96261 5.08944 7.94333 5.28431 8.07832L5.35355 8.13618L7 9.78286L10.6513 6.13131C10.8466 5.93605 11.1632 5.93605 11.3584 6.13131Z",
		fill: "#999999"
	})]
});
const ForwardRef = forwardRef(SvgTick);
export default ForwardRef;
